import api from "../../api.js";

export async function checkEligibility(payload) {
  const res = await api.post("/api/medikredit/eligibility", payload);
  return res.data;
}
